"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportCustomerExcel = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _utils = require("@/utils");
var _date = require("@/utils/date");
var Excel = _interopRequireWildcard(require("exceljs"));
var _fileSaver = require("file-saver");
// import { excludesFontStyleName, fontStyleName } from "@/utils/excel";

var exportCustomerExcel = exports.exportCustomerExcel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
    var customers, fileName, workbook, worksheet, fontRedBold, cellStyle, styleCell, columnTable, headerRow, columns, data, startRow, buffer, fileType, fileExtension, blob;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          customers = _ref.customers;
          console.log("customer", customers);
          fileName = "Danh s\xE1ch kh\xE1ch h\xE0ng";
          workbook = new Excel.Workbook();
          worksheet = workbook.addWorksheet("Khách hàng", {
            pageSetup: {
              fitToPage: true,
              fitToHeight: 5,
              fitToWidth: 7
            }
          });
          fontRedBold = {
            bold: true,
            size: 11,
            color: {
              argb: "ffff0202"
            }
          }; // style cell
          cellStyle = {
            border: {
              top: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              },
              left: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              },
              bottom: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              },
              right: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              }
            }
          };
          styleCell = {
            primaryCell: {
              font: {
                size: 12
              },
              border: cellStyle.border,
              alignment: {
                vertical: "middle",
                wrapText: true
              }
            },
            subCell: {
              font: {
                bold: true,
                color: {
                  argb: "ff427c27"
                },
                size: 10
              },
              border: cellStyle.border,
              alignment: {
                horizontal: "center",
                vertical: "middle"
              }
            },
            boldCell: {
              font: {
                bold: true,
                size: 14
              },
              border: cellStyle.border,
              alignment: {
                horizontal: "center",
                vertical: "middle",
                wrapText: true
              },
              fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "ffff01"
                },
                bgColor: {
                  argb: "ffff01"
                }
              }
            }
          }; //add table
          columnTable = [{
            label: "Họ và tên",
            style: styleCell.boldCell,
            width: 20,
            prop: "name"
          }, {
            label: "Ngày sinh",
            style: styleCell.boldCell,
            width: 20,
            prop: "dayOfBirth"
          }, {
            label: "Số điện thoại",
            style: styleCell.boldCell,
            width: 20,
            prop: "phone",
            numFmt: "#,##0"
          }, {
            label: "Giới tính",
            style: styleCell.boldCell,
            width: 20,
            prop: "gender",
            numFmt: "#,##0"
          }, {
            label: "Khu vực",
            style: styleCell.boldCell,
            width: 20,
            prop: "area.name",
            numFmt: "#,##0"
          }, {
            label: "Ngày tạo",
            style: styleCell.boldCell,
            width: 20,
            prop: "dateCreated"
          }];
          headerRow = worksheet.getRow(2);
          headerRow.values = columnTable.map(function (e) {
            return e.label;
          });
          headerRow.height = 50;
          headerRow.eachCell(function (cell, colNum) {
            // cell.value = columnTable[colNum - 1].label;
            cell.style = columnTable[colNum - 1].style;
          });
          columns = worksheet.columns;
          columns.forEach(function (col, i) {
            col.width = columnTable[i].width;
          });

          //generate data
          data = customers.map(function (e, index) {
            e.gender = e.gender == "FEMALE" ? "Nữ" : "Nam";
            e.dateCreated = (0, _date.formatDateTime)(e.dateCreated, "HH:mm, DD/MM/YYYY");
            var tmp = [];
            columnTable.forEach(function (col) {
              var value = (0, _utils.generateProp)(e, col.prop);
              var style = styleCell.primaryCell;
              tmp.push({
                value: value,
                style: style,
                numFmt: col.numFmt
              });
            });
            return tmp;
          });
          startRow = 3;
          data.forEach(function (element) {
            var row = worksheet.getRow(startRow++);
            row.values = element.map(function (e) {
              return e.value;
            });
            row.eachCell(function (cell, index) {
              var col = element[index - 1];
              // @ts-ignore
              cell.style = col.style;
              col.numFmt && (cell.numFmt = col.numFmt);
            });
          });
          _context.next = 20;
          return workbook.xlsx.writeBuffer();
        case 20:
          buffer = _context.sent;
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = ".xlsx";
          blob = new Blob([buffer], {
            type: fileType
          });
          (0, _fileSaver.saveAs)(blob, fileName + fileExtension);
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function exportCustomerExcel(_x) {
    return _ref2.apply(this, arguments);
  };
}();